function styleFormEmbed () {
  if ($('.spaced-section').length == 0 || $('.form-app').length > 0) return;
  const host = document.querySelector("shopify-forms-embed");
  if (!host || !host.shadowRoot) return false;

  if (host.shadowRoot.querySelector("style[data-custom-style]")) return true;

  const style = document.createElement("style");
  style.setAttribute("data-custom-style", "true");
  style.textContent = `
    form._formFieldset_cit2d_82 {
      flex-flow: wrap !important;
      gap: 16px 24px !important;
    }

    @media screen and (max-width: 960px) {
      form._formFieldset_cit2d_82 {
        gap: 16px !important;
      }
    }

    ._formFieldset_cit2d_82 > div:not(._formFieldContainer_1mxsl_5) {
      display: none;
    }

    ._noImage_1q1d2_161 {
      max-width: 55% !important;
      margin: 0 !important;
      gap: 16px;
    }
    @media screen and (max-width: 960px) {
      ._noImage_1q1d2_161 {
        max-width: 100% !important;
      }
    }

    h2._textHeading_2aowh_35 {
      width: fit-content;
      color: #1F1F1F !important;
      font-family: "Albert Sans" !important;
      font-size: 32px !important;
      font-style: normal !important;
      font-weight: 300 !important;
      line-height: 113% !important;
      letter-spacing: 0.4px !important;
    }
    ._formHeader_cit2d_24,
    h2._textHeading_2aowh_35 {
      margin: 0 !important;
      margin-bottom: 16px !important;
    }

    ._formFieldContainer_ck6wz_5 {
      max-width: calc(100% - 282px - 16px);
      order: 1;
      flex: 1;
    }

    ._formError_ck6wz_21 {
      order: 3;
      width: 100%;
    }

    ._formFieldContainer_1mxsl_5 {
      max-width: calc(100% - 282px - 24px);
      flex: 1;
    }

    input[type="text"], input[type="email"] {
      height: 60px !important;
      box-sizing: border-box !important;
      border-radius: 8px !important;
      border: 1px solid rgba(31, 31, 31, 0.16) !important;
      background: transparent !important;

      color: rgba(55, 55, 55, 1) !important;
      font-family: "Albert Sans" !important;
      font-size: 16px !important;
      font-style: normal !important;
      font-weight: 400 !important;
      line-height: normal !important;
      letter-spacing: 0.64px !important;
    }

    label._formInputFieldLabel_1mxsl_38 {
      top: 23px !important;
    }

    ._consentCheckboxContainer_cit2d_49 {
      order: 4;
      width: 100%;
    }

    ._checkboxField_1hja3_3 {
      grid-template-columns: auto minmax(0, 1fr) !important;
    }

    #emailConsent-true {
      margin: 0;
      width: 16px;
      height: 16px;
      appearance: none;
      border-radius: 4px;
      border: 1px solid rgba(31, 31, 31, 0.08);
      background: rgba(31, 31, 31, 0.1);
      color: #1f1f1f;
      cursor: pointer;
    }

    #emailConsent-true:checked {
      background: linear-gradient(currentColor) center no-repeat;
      background-size: 1.2rem 1.2rem;
    }

    ._textBody_2aowh_10 {
      color: #1F1F1F !important;
      font-family: "Albert Sans" !important;
      font-size: 14px !important;
      font-style: normal !important;
      font-weight: 400 !important;
      line-height: normal !important;
      letter-spacing: -0.28px !important;
      text-transform: uppercase !important;
      cursor: pointer;
    }

    button[type="submit"] {
      max-width: 282px !important;
      width: 100% !important;
      height: 60px !important;
      box-sizing: border-box !important;
      text-align: center !important;
      font-family: "Albert Sans" !important;
      font-size: 16px !important;
      font-style: normal !important;
      font-weight: 600 !important;
      line-height: normal !important;
      letter-spacing: -0.32px !important;
      text-transform: uppercase !important;
      order: 2 !important;
      padding: 20px 24px !important;
      border-radius: 8px !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
    }

    button[type="submit"] span {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 2px;
    }

    @media screen and (max-width: 960px) {
      ._formFieldContainer_1mxsl_5 {
        max-width: calc(100% - 110.45px - 16px) !important;
      }
      h2._textHeading_2aowh_35 {
        font-size: 24px !important;
      }
      button[type="submit"] {
        max-width: fit-content !important;
        padding: 16px !important;
      }
    }
  `;
  host.shadowRoot.appendChild(style);

  return true;
}

// 外部表单未加载时停止轮询，避免整页生命周期内持续空转。
let formEmbedTries = 0;
const interval = setInterval(() => {
  if (styleFormEmbed() || ++formEmbedTries >= 60) {
    clearInterval(interval);
  }
}, 500);
